export const contactEmail = 'MiddledotTech@gmail.com';
export const companyName = 'Middledot Tech, LLC';
export const intervalTimerAppName = 'Interval Timer Unlimited'
